// extracted by mini-css-extract-plugin
module.exports = {"Component":"CustomerAccountTypeBadge_Component__YWwWb"};